import React, { Component } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import './CreatePopMenu.scss';
import ImgTag from '../../Atoms/ImgTag';
import newAddIcon from '../../../../assets/icons/ic_add_circle_blue.png';
import UlList from '../../Atoms/UlList';
import CreateModal from '../../../Components/CreateModal';

class CreatePopMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverObj: false,
            selectedMenuType: ''
        }
    }

    updateCurrentSelectedMenu = (value) => {
        this.setState({selectedMenuType: value});
    }

    render() {
        const createMenuClass = 'create-menu-wrapper' + (this.state.selectedMenuType !== ''? ' active': '');
        return (
            <div className = 'body-menu-popover-wrapper'>
            <Popover
                isOpen={this.state.popoverObj}
                positions={["left","right", "bottom", "top"]}
                reposition={true}
                padding={5}
                parentElement={document.getElementById('mainBodySection')}
                onClickOutside={() => {
                    this.setState({ popoverObj: false })
                }}
                containerClassName = 'create-popmenu-list-container-wrapper'
                content={({ position, childRect, popoverRect }) => (
                    <ArrowContainer 
                    position={position}
                    childRect={childRect}
                    popoverRect={popoverRect}
                    arrowColor={"#fff"}
                    arrowSize={10}
                    arrowStyle={{ opacity: 1 }}
                    >
                    <div
                        style={{ backgroundColor: "#fff", opacity: 1, boxShadow: '0px 0px 10px #00000040', borderRadius: '5px', padding: '5px 15px', display: 'flex', flexDirection: 'column', minWidth: '100px', maxWidth: '180px' }}
                        onClick={() => {
                            this.setState({ popoverObj: !this.state.popoverObj });
                        }}
                    >
                        <UlList
                            listContainerClass = 'create-popmenu-list-container'
                            listItems = {[{name: 'Switch Toggle', value: 'switchtoggle'}, {name: 'Radio Toggle', value: 'radiotoggle'}, {name: 'Text Field', value: 'textfield'}, {name: 'Number Field', value: 'numberfield'}, {name: 'Text Array Field', value: 'arrayfield'}, {name: 'Group', value: 'groupfield'}, {name: 'Object Group', value: 'objectGroupfield'}]}
                            listItemClass = 'create-popmenu-list-item'
                            onListItemClick = {(target) => {
                                this.updateCurrentSelectedMenu(target.target.getAttribute('value'));
                            }}
                        />
                    </div>
                    </ArrowContainer>
                )}
                >
                    <button title = 'Add' className = {this.props.className} type = 'button' onClick={() => {
                        this.setState({ popoverObj: !this.state.popoverObj });
                    }}>
                        <span className = 'eb-icon-btn-image'>
                            <ImgTag
                                className = 'image'
                                src = {newAddIcon}
                                alt = 'Create New'
                            />
                        </span>
                    </button>
            </Popover>
            <div className = {createMenuClass} onClick = {() => {this.updateCurrentSelectedMenu('')}}>
                <CreateModal
                    parentArray = {this.props.parentArray}
                    selectedMenuType = {this.state.selectedMenuType}
                    updateCurrentSelectedMenu = {this.updateCurrentSelectedMenu}
                />
            </div>
            </div>
        )
    }
}

export default CreatePopMenu;